<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <pageheader :page-name="pageName" parent-page-name="Public Relations" parent-page-url="/public-relations" />
      <add-edit-form
        v-if="model"
        returnUrl="/public-relations"
        :apiBaseUrl="API_BASE_URL"
        :model="model"
        :fields="fields"
        :toEdit="toEdit"
      />
    </div>
    <!-- Content Wrapper END -->
  </div>
</template>

<script>
import Pageheader from '@/components/Pageheader.vue'
import AddEditForm from '@/components/AddEditForm.vue'
import PublicRelation from '@/models/PublicRelation'
/* eslint-disable no-undef */
export default {
  name: 'AddPublicRelation',
  components: {
    Pageheader,
    AddEditForm
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    },
    pageName () {
      return this.toEdit ? 'Edit Public Relation' : 'Add Public Relation'
    }
  },
  data () {
    return {
      API_BASE_URL: 'publicrelation',
      model: null,
      fields: [
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Sort number', key: 'sort_no', type: 'number' },
        { label: 'Powerpoint Format', key: 'powerpoint', type: 'format' },
        { label: 'PDF Format', key: 'PDF', type: 'format' },
        { label: 'Word Format', key: 'WORD_DOC', type: 'format' },
        { label: 'All Formats', key: 'ALL', type: 'format' }
      ]
    }
  },
  mounted () {
    if (this.toEdit) {
      this.fetch()
    } else {
      this.model = new PublicRelation()
    }
  },
  methods: {
    fetch () {
      this.$store.dispatch(this.API_BASE_URL + '/get', this.$route.params.id)
        .then((result) => {
          this.model = new PublicRelation(result.public_relation)
        })
        .catch((err) => this.$helper.catchHandler(err))
      return null
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/PublicRelations/AddEdit.vue